import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aad3d74a"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = {
  class: "filter-title-popover-content"
};
const _hoisted_3 = {
  class: "filter-title-popover-count"
};
const _hoisted_4 = {
  class: "filter-title-popover-title"
};
const _hoisted_5 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_CircularIndicator = _resolveComponent("CircularIndicator");
  const _component_FlexRow = _resolveComponent("FlexRow");
  return _openBlock(), _createBlock(_component_FlexRow, {
    class: _normalizeClass(["filter-item-selector", [{
      hovered: $data.hovered,
      disabled: $props.disabled
    }]]),
    gap: 8,
    onMouseover: _cache[0] || (_cache[0] = $event => $data.hovered = true),
    onMouseleave: _cache[1] || (_cache[1] = $event => $data.hovered = false),
    onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('click'))
  }, {
    default: _withCtx(() => [$options.hasPopover ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
      key: 0,
      target: `title-${$props.id}`,
      placement: "bottom",
      width: "fit-content",
      customClass: "filter-title-popover"
    }, {
      title: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString($options.getSelectedCount) + " Selected:", 1), _createElementVNode("div", _hoisted_4, _toDisplayString($props.selectedTitle), 1)])]),
      default: _withCtx(() => [_createVNode(_component_flex_row, {
        id: `title-${$props.id}`,
        gap: 8
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "title", {}, () => [(_openBlock(), _createBlock(_resolveDynamicComponent($props.icon), {
          width: "16",
          height: "16",
          color: $props.disabled ? '#999999' : $props.color
        }, null, 8, ["color"])), _createElementVNode("span", {
          class: "title",
          innerHTML: $props.title
        }, null, 8, _hoisted_1)], true)]),
        _: 3
      }, 8, ["id"])]),
      _: 3
    }, 8, ["target"])) : (_openBlock(), _createBlock(_component_flex_row, {
      key: 1,
      gap: 8
    }, {
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "title", {}, () => [(_openBlock(), _createBlock(_resolveDynamicComponent($props.icon), {
        width: "16",
        height: "16",
        color: $props.disabled ? '#999999' : $props.color
      }, null, 8, ["color"])), _createElementVNode("span", {
        class: "title",
        innerHTML: $props.title
      }, null, 8, _hoisted_5)], true)]),
      _: 3
    })), !$props.noCount ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [$props.selectedCount > 0 && $data.hovered && !$props.no_reset ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
      key: 0,
      target: `reset-${$props.id}`,
      width: "fit-content"
    }, {
      title: _withCtx(() => [_createTextVNode("Reset all selection")]),
      default: _withCtx(() => [_createVNode(_component_CircularIndicator, {
        id: `reset-${$props.id}`,
        onClick: _withModifiers($options.clearAndApply, ["stop"]),
        background: "#669EFF",
        hoverBackground: "#4C8EFF"
      }, {
        default: _withCtx(() => [_createVNode(_component_AppIcon, {
          icon: "cross",
          size: 12,
          color: "#FFFFFF"
        })]),
        _: 1
      }, 8, ["id", "onClick"])]),
      _: 1
    }, 8, ["target"])) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [$props.selectedCount > 0 ? (_openBlock(), _createBlock(_component_CircularIndicator, {
      key: 0,
      width: "auto"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($options.getSelectedCount), 1)]),
      _: 1
    })) : _createCommentVNode("", true)], 64))], 64)) : _createCommentVNode("", true), !$props.noCaret ? (_openBlock(), _createBlock(_component_AppIcon, {
      key: 3,
      icon: "simple-arrow-down",
      color: $props.color,
      size: 16
    }, null, 8, ["color"])) : _createCommentVNode("", true)]),
    _: 3
  }, 8, ["class"]);
}